/**
 * Relevant images for mall / retail / real estate.
 * Prefer local files in public/ (e.g. /front.jpg).
 */

export const siteImages = {
  /** Hero: mall/shopping center. */
  hero: '/front.jpg',
  heroFallback: '/front.jpeg',

  /** Retail / store interior */
  retailInterior: '/GAX_8498.jpg',
  retailInteriorFallback: '/GAX_8388.jpg',

  /** Mall interior / corridor */
  mallInterior: '/GAX_8388.jpg',
  mallInteriorFallback: '/GAX_8498.jpg',

  /** Visit Us section */
  visitUs: '/GAX_8348.jpg',
  visitUsFallback: '/GAX_8498.jpg',
} as const;
